module.exports = __webpack_public_path__ + "img/home-slide3-gr-2x.af2102fd.png";